import React from 'react';
import {PackageSearchData} from "./PackageSearchData";
import FiltersDataContextProvider from "../../commons/context/FiltersDataContext";
import FiltersStateContextProvider from '../../commons/context/FiltersStateContext';
import ViewDataContextProvider from "../../commons/context/view/ViewDataContext.js";

const PackageSearchView = (props) => {

        return (
            <FiltersDataContextProvider>
              <FiltersStateContextProvider context = {props.match.params.context}>
              <ViewDataContextProvider>
                <PackageSearchData history={props.history} location={props.location}/>
              </ViewDataContextProvider>
              </FiltersStateContextProvider>   
            </FiltersDataContextProvider>
        )
}

export default PackageSearchView;


// WEBPACK FOOTER //
// ./src/components/packageList/PackageSearchView.js